/* vm-course-check.js
   Zweck:   Kurs-Check in vm-course-faqcheck: sobald alle Fragen beantwortet sind, Ergebnis anzeigen.
            Logik: eine "stop"-Antwort → stop; sonst eine "later" → later; sonst ok. Keine Datenübertragung.
   Basis:   Concept 6.0.x — Custom Element, kein globaler State
   Deps:    sections/vm-course-faqcheck.liquid, assets/vm-course.css
*/
class VmCourseCheck extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.onChange);
  }
  disconnectedCallback() { this.removeEventListener('change', this.onChange); }
  onChange = () => {
    const groups = new Map();
    this.querySelectorAll('input[type=radio]').forEach(i => { if (!groups.has(i.name)) groups.set(i.name, null); if (i.checked) groups.set(i.name, i.value); });
    const values = [...groups.values()];
    if (values.some(v => v === null)) return;
    const outcome = values.includes('stop') ? 'stop' : (values.includes('later') ? 'later' : 'ok');
    const res = this.querySelector('[data-vm-check-result]');
    if (!res) return;
    const title = res.getAttribute('data-title-' + outcome) || '';
    const text = res.getAttribute('data-text-' + outcome) || '';
    const t = this.querySelector('[data-vm-check-title]'); if (t) t.textContent = title;
    const p = this.querySelector('[data-vm-check-text]'); if (p) p.textContent = text;
    const cta = this.querySelector('[data-vm-check-cta]'); if (cta) cta.hidden = (outcome === 'stop');
    this.classList.add('is-done');
    res.setAttribute('role', 'status');
  };
}
if (!customElements.get('vm-course-check')) customElements.define('vm-course-check', VmCourseCheck);
